import React, { useEffect, useRef, useState } from 'react';
import { styles } from '../styles';

let timer;

const Input = ({ data, editorInfo, editTableData, onUpdate }) => {
  const classes = styles();

  const inputRef = useRef(null);

  const [value, setValue] = useState(data);

  const handleUpdateChart = (data) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      onUpdate(data);
      clearTimeout(timer);
    }, 100);
  };

  const handleChange = (e) => {
    const { isColHead, isRowHead, index, row } = editTableData;
    const { categories, series } = JSON.parse(editorInfo.data);

    const numericValue = parseInt(e.target.value === '' ? 0 : e.target.value);
    if (isNaN(numericValue) && !isColHead && !isRowHead) return;

    let value = e.target.value;
    if (!isColHead && !isRowHead) {
      value = value === '' ? 0 : parseInt(e.target.value);
    }
    setValue(value);

    const data = {
      categories: [],
      series: [],
    };

    if (isColHead) {
      data.series = series;
      data.categories = categories.map((item, idx) => (idx === index ? value : item));
    } else if (isRowHead) {
      data.series = series.map((item, idx) => (idx === index ? { ...item, name: value } : item));
      data.categories = categories;
    } else {
      data.series = series.map((item, idx) =>
        idx === index
          ? { ...item, data: [...item.data.slice(0, row), parseInt(value), ...item.data.slice(row + 1)] }
          : item,
      );
      data.categories = categories;
    }

    handleUpdateChart(data);
  };

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.select();
    }
    return () => {
      if (inputRef.current) {
        inputRef.current.blur();
      }
    };
  }, [inputRef]);

  return (
    <input
      ref={inputRef}
      className={classes.input}
      value={value}
      onChange={handleChange}
      onKeyDown={(e) => {
        e.stopPropagation();
      }}
    />
  );
};

export default Input;
